export default __webpack_public_path__ + "static/Sylog-d897bdb7ea0d57f98ff45630c05a8b8b.png";